export default "__VITE_ASSET__D_hjWS0F__"